import { Injectable } from "@angular/core";
import { environment } from "@env/environment";


@Injectable({
    providedIn: 'root'
})
export class OneIncHelperService {
    public injectScript() {
        const oneIncScriptEl = document.createElement('script');
        let oneIncScriptUrl = '';
        oneIncScriptUrl = environment.oneIncScript;
        oneIncScriptEl.setAttribute('src', oneIncScriptUrl);
        oneIncScriptEl.setAttribute('async', '');
        oneIncScriptEl.setAttribute('defer', '');
        // oneIncScriptEl.async= true;
        // oneIncScriptEl.defer= true;
        document.head.appendChild(oneIncScriptEl);
    }
}